import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var Features = /*#__PURE__*/function (Features) {
  return Features;
}({});
export var getUtils = function getUtils(ctx) {
  function keepQuery(location) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var query = _objectSpread(_objectSpread(_objectSpread({}, ctx.route.query || {}), location.query || {}), extra.query || {});
    var params = _objectSpread(_objectSpread(_objectSpread({}, ctx.route.params || {}), location.params || {}), extra.params || {});
    return _objectSpread(_objectSpread({}, location), {}, {
      query: query,
      params: params
    });
  }
  function nuxtErrorPage(error) {
    var sentryError = ctx.$sentryUtils.error(error, {
      place: 'nuxtErrorPage'
    });
    if (!sentryError) return;
    ctx.error(sentryError);
  }
  var routeReplaceWithQuery = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location, extra) {
      var _ctx$app$router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_ctx$app$router = ctx.app.router) === null || _ctx$app$router === void 0 ? void 0 : _ctx$app$router.replace(keepQuery(location, extra));
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function routeReplaceWithQuery(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var routePushWithQuery = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(location, extra) {
      var _ctx$app$router2;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (_ctx$app$router2 = ctx.app.router) === null || _ctx$app$router2 === void 0 ? void 0 : _ctx$app$router2.push(keepQuery(location, extra));
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function routePushWithQuery(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
  var redirectWithQuery = function redirectWithQuery(location, extra) {
    var statusCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 302;
    return ctx.redirect(statusCode, keepQuery(location, extra));
  };

  /**
   * Return raw data instead of Observer
   * TODO: move to development utils
   */
  var toRaw = function toRaw(data) {
    return JSON.parse(JSON.stringify(data));
  };

  /**
   * Is value null or underfined
   * Helper for templates, cuz we don't have nullish coalescing operator in vue templates.
   * FIXME: we could move such functions to $template or smth like that
   */
  var isNullish = function isNullish(value) {
    return value === null || typeof value === 'undefined';
  };
  var isFeatureEnabled = function isFeatureEnabled(feature) {
    var _ctx$$auth$user, _ctx$$auth$user$enabl;
    return ((_ctx$$auth$user = ctx.$auth.user) === null || _ctx$$auth$user === void 0 ? void 0 : (_ctx$$auth$user$enabl = _ctx$$auth$user.enabledFeatures) === null || _ctx$$auth$user$enabl === void 0 ? void 0 : _ctx$$auth$user$enabl.some(function (f) {
      return f.key === feature;
    })) || false;
  };
  return {
    nuxtErrorPage: nuxtErrorPage,
    routeReplaceWithQuery: routeReplaceWithQuery,
    routePushWithQuery: routePushWithQuery,
    redirectWithQuery: redirectWithQuery,
    toRaw: toRaw,
    isNullish: isNullish,
    isFeatureEnabled: isFeatureEnabled
  };
};
export default (function (ctx, inject) {
  var utils = getUtils(ctx);
  inject('utils', utils);
});